import TableRow from "@mui/material/TableRow"

import { NoWrapTableCell } from "./cells"

export default function NoResultsTableRow({ colSpan }) {
  return (
    <TableRow>
      <NoWrapTableCell sx={{ textAlign: "center" }} colSpan={colSpan}>
        No data to show here
      </NoWrapTableCell>
    </TableRow>
  )
}
